import { useNavigate } from 'react-router-dom';
import { usePageTitle } from '@/hooks/usePageTitle';

export function NotFoundPage() {
    usePageTitle('Page Not Found');

    const navigate = useNavigate();

    const handleBack = () => {
        navigate(-1);
    };

    const handleHome = () => {
        navigate('/');
    };

    return (
        <div className="flex min-h-screen items-center justify-center bg-neutral-100 px-4 dark:bg-darker">
            <div className="w-full max-w-2xl space-y-8">
                <h1 className="font-serif text-7xl font-normal text-gray-900 dark:text-white md:text-8xl">
                    Hmm.
                </h1>

                <div className="space-y-4">
                    <p className="text-xl text-gray-900 dark:text-white md:text-2xl">
                        Looks like this page doesn't exist.
                    </p>

                    <p className="text-xl text-gray-900 dark:text-white md:text-2xl">
                        Let us help guide you out and get you back home.
                    </p>
                </div>

                <div className="flex gap-4 pt-4">
                    <button
                        onClick={handleBack}
                        className="border-2 border-gray-900 bg-transparent px-8 py-3 text-sm font-medium uppercase tracking-wider text-gray-900 transition-colors hover:bg-gray-900 hover:text-white dark:border-white dark:text-white dark:hover:bg-white dark:hover:text-gray-900"
                    >
                        BACK
                    </button>
                    <button
                        onClick={handleHome}
                        className="border-2 border-gray-900 bg-transparent px-8 py-3 text-sm font-medium uppercase tracking-wider text-gray-900 transition-colors hover:bg-gray-900 hover:text-white dark:border-white dark:text-white dark:hover:bg-white dark:hover:text-gray-900"
                    >
                        HOME
                    </button>
                </div>
            </div>
        </div>
    );
}
